export default {
  title: 'Sigur doriți să ștergeți contul?',
  description:
    'Această acțiune este permanentă. Veți pierde accesul la comenzi, puncte de fidelitate și preferințele salvate.',
  labels: {
    loading: 'Se șterge contul...',
  },
  buttons: {
    confirm: 'Confirmați',
    cancel: 'Anulați',
  },
  toasts: {
    success:
      'Contul dvs. a fost șters permanent. Nu mai aveți acces la istoricul comenzilor, punctele de fidelitate sau datele salvate.',
    error:
      'Ceva a mers greșit. Încercați din nou. Dacă problema persistă, contactați echipa noastră de asistență: {{supportEmail}}',
  },
};
